import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import RobotIcon from '@zola/zola-ui/src/components/SvgIcons/RobotIcon';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import './NoProductResult.less';

export default function NoProductResult({ onClearAll }) {
  const containerClass = cx('no-product__container');
  return (
    <div className={containerClass}>
      <RobotIcon className="no-product__icon" width={80} height={80} viewBox="0 0 115 115" />
      <h3 className="no-product__title">
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Hm... we couldn't find any items that match what you're searching for.
      </h3>
      {!!onClearAll && (
        <>
          <div className="no-product__sub-title">
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Try clearing your filters to find what you're looking for.
          </div>
          <ButtonV2
            className="no-product__button"
            variant="primary"
            type="button"
            onClick={onClearAll}
          >
            Clear All Filters
          </ButtonV2>
        </>
      )}
    </div>
  );
}

NoProductResult.propTypes = {
  onClearAll: PropTypes.func,
};
